import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import log from 'lib/log'
import { unpublishPost, goToPost } from 'state/actions/posts'
import LoadingLoadedOrExploded from 'components/LoadingLoadedOrExploded'
import ArticleList from 'components/ArticleList'
import Menu from 'components/Menu'
import MenuItem from 'components/MenuItem'
import { useAssetEditor } from 'assets/useAssetEditor'
import { Post } from 'lib-core'
import { postCircleUrl } from 'circle/places'
import { useHistory } from 'react-router-dom'

const PostList = (props) => {
  const history = useHistory()
  const reloadPosts = async () => {
      await props.loadPosts({
        author: props.author._id
      })
  }
  
  const { editAsset, editDialog } = useAssetEditor((asset: Post) => {
    history.push(postCircleUrl(asset))
  })  

  const handleUnpublish = async (target) => {
    try {
      await props.unpublishPost(target)
      await reloadPosts()
    } catch (err) {
      log.error(err)
    }
  }

  const renderOverflowMenu = (target) => {
    return (
      <Menu context={target}>
        <MenuItem label="posts.edit" onClick={async (post: Post)=>{
          if (await editAsset(post)) {
            return
          }         
          props.onEditClick(post)
        }} />
        <MenuItem label="posts.unpublish" onClick={handleUnpublish} />
      </Menu>
    )
  }

  return (
    <>
      <ArticleList {...props} overflowMenu={renderOverflowMenu} />
      {editDialog}
    </>
  )

}

const Posts = ({
  handlePostClick,
  handleEditClick,
  unpublishPost,
  loadPosts,
  isMine,
  author,
  posts: { map: content, list: { loading, error, values: order, range } = {} }
}) => {
  const loaded = content
    ? { content, order, range, unpublishPost, loadPosts, author }
    : undefined
  return (
    <LoadingLoadedOrExploded
      loading={loading || !(content || error)}
      loaded={loaded}
      error={error && error.message ? error.message : error}
      loadedComponent={isMine ? PostList : ArticleList}
      onPostClick={handlePostClick}
      onEditClick={handleEditClick}
    />
  )
}

const mapStateToProps = ({ posts }, props) => ({ posts })
const mapDispatchToProps = dispatch => {
  return {
    handlePostClick: ({ name, author: { username }, group, _id }) => {
      dispatch(goToPost({ name, username, group, _id }))
    },
    unpublishPost: bindActionCreators(unpublishPost, dispatch),
    handleEditClick: ({ draft, type }) => {
      dispatch({
        type: 'profile/drafts/_edit/compose',
        payload: {
          postType: type,
          postId: draft
        }
      })
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Posts)
